import type { IxcDtccDtcV1AssetDayKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const DTC_ASSET_DAY_BASE_PATH = getResolvedPath('/clearing/operations/dtcc/asset');

export const getDtcAssetDayPath: EntityPathBuilder<IxcDtccDtcV1AssetDayKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return DTC_ASSET_DAY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.assetId || !context?.keys?.date) {
        return undefined;
      }

      return getResolvedPath(`${DTC_ASSET_DAY_BASE_PATH}/$assetId/$date`, context?.keys);
    }
  }
};

export function getDtcAssetDayDetailPath(assetId: string | undefined, date: string | undefined) {
  if (!assetId || !date) {
    return undefined;
  }

  return getDtcAssetDayPath({ kind: 'detail', keys: { assetId, date } });
}
